import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { yearLabel } from "@/components/shared";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Sparkles, BookOpen, Gamepad2, FolderOpen, ArrowRight } from "lucide-react";

const TIPS = [
  { icon: BookOpen, label: "Mes cours", desc: "Suis tes séances et rattrape celles que tu as manquées." },
  { icon: Gamepad2, label: "M'entraîner", desc: "Des QCM auto-corrigés pour réviser à ton rythme." },
  { icon: FolderOpen, label: "Mon portfolio", desc: "Dépose tes preuves et fais grandir tes compétences." },
];

export default function WelcomeDialog({ onClose }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(true);

  const close = () => {
    sessionStorage.removeItem("mz_first_login");
    setOpen(false);
    onClose?.();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) close(); }}>
      <DialogContent className="rounded-3xl max-w-lg p-0 overflow-hidden" data-testid="welcome-dialog">
        <div className="bg-gradient-to-br from-sky-500 to-sky-600 text-white px-7 py-6">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
              <Sparkles className="h-6 w-6" />
            </div>
            <DialogHeader className="space-y-0 text-left">
              <DialogTitle className="font-display text-xl font-semibold text-white" data-testid="welcome-title">
                Bienvenue {user?.first_name} !
              </DialogTitle>
              <p className="text-sky-50 text-sm font-medium">
                C'est ta première connexion à MerryZone · CAP EPC {yearLabel(user?.year)}
              </p>
            </DialogHeader>
          </div>
        </div>

        <div className="px-6 py-5 space-y-3">
          {TIPS.map(({ icon: Icon, label, desc }) => (
            <div key={label} className="rounded-2xl border border-slate-100 bg-slate-50 p-4 flex items-center gap-3">
              <div className="h-10 w-10 rounded-xl bg-white flex items-center justify-center shrink-0 text-sky-600">
                <Icon className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <p className="font-bold text-slate-800">{label}</p>
                <p className="text-sm text-slate-500">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="px-6 py-4 border-t border-slate-100 flex justify-end">
          <button onClick={close} data-testid="welcome-start-btn"
            className="inline-flex items-center gap-1.5 rounded-full bg-sky-600 hover:bg-sky-700 text-white font-bold text-sm px-5 py-2.5 transition-colors">
            C'est parti <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
